import { AnyAction } from "redux";
import {
  ADD_HAZARD_QUESTION_RESPONSE,
  HAS_ACTIVE_HAZARD_CASE,
  REMOVE_HAZARD_QUESTION_RESPONSE,
  SAVE_GET_HAZARD_API_RESPONSE,
  SAVE_HAZARD_ACCESS_RESPONSE,
  SAVE_HAZARD_VALUES,
  SAVE_HHSRS_ASSESSMENT_COMPLETED,
  SAVE_POST_HAZARD_ASSESSMENT_RESPONSE,
  SAVE_PRE_ASSESSMENT_OUTCOME,
  SAVE_PRE_ASSESSMENT_QUESTIONS_RESPONSE,
  SAVE_PRE_ASSESSMENT_RETURN_QUESTION,
  UPDATE_HAZARD_QUESTION_RESPONSE,
  SAVE_ACTIVE_HAZARD_CASE
} from "../actionTypes";
import { Case } from "../../../models/Case/CaseSearch";

interface HazardQuestionResponse {
  id: number;
  question: string;
  answer: string;
  answerCodes: number;
  code: string;
}
export interface HazardAssessmentState {
  responses: HazardQuestionResponse[];
  assessment: null;
  hazardQuestions: any[];
  hazardValues: any[];
  isHHSRSAssessmentCompleted: boolean;
  preAssessmentReturnQuestion: { code: string; from: string };
  preAssessmentJourneyQuestions: any[] | null;
  preAssessmentOutcome: string;
  hazardPostAccessResponse: {};
  activeHazardCaseDetails: Case | null;
}

// define initial state of reducer by default empty
const initialState: HazardAssessmentState = {
  responses: [],
  assessment: null,
  hazardQuestions: [],
  isHHSRSAssessmentCompleted: false,
  preAssessmentReturnQuestion: { code: "", from: "" },
  preAssessmentJourneyQuestions: null,
  preAssessmentOutcome: "",
  hazardPostAccessResponse: {},
  hazardValues: [],
  activeHazardCaseDetails: null
};

export const hazardReducer = (state: any = initialState, action: AnyAction) => {
  switch (action.type) {
    case ADD_HAZARD_QUESTION_RESPONSE:
      return {
        ...state,
        responses: [...state.responses, action.payload],
      };

    // Updating question seq according to depends on
    case UPDATE_HAZARD_QUESTION_RESPONSE: {
      const updatedResponses = state.responses.map((item: any) =>
        item.code === action.payload.code
          ? {
            ...item,
            answers: action.payload.answers,
            answerCodes: action.payload.answerCodes,
          }
          : item,
      );

      const allQuestions = state.hazardQuestions || [];

      let filteredResponses = updatedResponses;

      allQuestions.forEach((dependentQuestion: any) => {
        if (!dependentQuestion.dependsOn?.length) {
          return;
        }

        dependentQuestion.dependsOn.forEach((dependency: any) => {
          if (dependency.code !== action.payload.code) {
            return;
          }

          const selectedAnswers = Array.isArray(action.payload.answerCodes)
            ? action.payload.answerCodes.map(String)
            : [String(action.payload.answerCodes)];

          const dependencyResponses = Array.isArray(dependency.responses)
            ? dependency.responses
            : [];

          const dependencyMatched = dependencyResponses.some(
            (responseCode: string) =>
              selectedAnswers.includes(String(responseCode)),
          );

          if (!dependencyMatched) {
            return;
          }

          const parentQuestion = allQuestions.find(
            (q: any) => q.code === dependency.code,
          );

          if (!parentQuestion) {
            return;
          }

          const questionsBetween = allQuestions.filter(
            (q: any) =>
              q.sequence > parentQuestion.sequence &&
              q.sequence < dependentQuestion.sequence,
          );

          const codesToRemove = new Set(
            questionsBetween.map((q: any) => q.code),
          );

          filteredResponses = filteredResponses.filter(
            (response: any) => !codesToRemove.has(response.code),
          );
        });
      });

      return {
        ...state,
        responses: filteredResponses.map((item: any) => {
          const matchingQuestion = allQuestions.find(
            (question: any) => question.code === item.code,
          );

          return {
            ...item,
            sequence: matchingQuestion?.sequence ?? item.sequence,
          };
        }),
      };
    }
    // End update

    case SAVE_GET_HAZARD_API_RESPONSE:
      return {
        ...state,
        hazardQuestions: action.payload,
      };

    case REMOVE_HAZARD_QUESTION_RESPONSE:
      return {
        ...state,
        responses: initialState.responses,
        assessment: initialState.assessment,
        hazardQuestions: initialState.hazardQuestions,
        isHHSRSAssessmentCompleted: initialState.isHHSRSAssessmentCompleted,
        preAssessmentReturnQuestion: initialState.preAssessmentReturnQuestion,
        preAssessmentOutcome: initialState.preAssessmentOutcome,
        hazardPostAccessResponse: initialState.hazardPostAccessResponse
      };

    case SAVE_POST_HAZARD_ASSESSMENT_RESPONSE:
      return {
        ...state,
        assessment: action.payload
      };
    case SAVE_PRE_ASSESSMENT_RETURN_QUESTION:
      return {
        ...state,
        preAssessmentReturnQuestion: action.payload
      };
    case SAVE_HHSRS_ASSESSMENT_COMPLETED:
      return {
        ...state,
        isHHSRSAssessmentCompleted: action.payload,
      };
    case SAVE_PRE_ASSESSMENT_QUESTIONS_RESPONSE:
      return {
        ...state,
        preAssessmentJourneyQuestions: action.payload
      };
    case SAVE_PRE_ASSESSMENT_OUTCOME:
      return {
        ...state,
        preAssessmentOutcome: action.payload
      };
    case SAVE_HAZARD_ACCESS_RESPONSE:
      return {
        ...state,
        hazardPostAccessResponse: action.payload
      };
    case HAS_ACTIVE_HAZARD_CASE:
      return {
        ...state,
        hasActiveHazardCase: action.payload,
      };
    case SAVE_HAZARD_VALUES:
      return {
        ...state,
        hazardValues: action.payload,
      };
    case SAVE_ACTIVE_HAZARD_CASE:
      return {
        ...state,
        activeHazardCaseDetails: action.payload,
      };
    default:
      return state;
  }
};

export default hazardReducer;